module.exports = __webpack_public_path__ + "static/media/mytrips_light_ic.6a422815.svg";